export default ({ configs }) => {
  return [
    {
      name: configs?.[0]?.name,
      max_team_member: configs?.[0]?.max_team_member,
      max_socmed_account: configs?.[0]?.max_socmed_account,
      email_support: 24,
      base_features: true,
      post_integration: false,
      roles_management: false,
      assigned_accounts_partner: false,
      social_accounts_calender: true,
      social_accounts_stream: true,
      social_accounts_messaging: true,
      social_accounts_posting: true,
      add_social_accounts: true,
      social_advertising_publishing: true,
      social_advertising_calender: true,
      social_advertising_reporting: true,
      post_integration_reporting: false,
      add_client_users: false,
    },
    {
      name: configs?.[1]?.name,
      max_team_member: configs?.[1]?.max_team_member,
      max_socmed_account: configs?.[1]?.max_socmed_account,
      email_support: 12,
      base_features: true,
      post_integration: true,
      roles_management: true,
      assigned_accounts_partner: false,
      social_accounts_calender: true,
      social_accounts_stream: true,
      social_accounts_messaging: true,
      social_accounts_posting: true,
      add_social_accounts: true,
      social_advertising_publishing: true,
      social_advertising_calender: true,
      social_advertising_reporting: true,
      post_integration_reporting: true,
      add_client_users: true,
    },
    {
      name: configs?.[2]?.name,
      max_team_member: configs?.[2]?.max_team_member,
      max_socmed_account: configs?.[2]?.max_socmed_account,
      email_support: 6,
      base_features: true,
      post_integration: true,
      roles_management: true,
      assigned_accounts_partner: true,
      social_accounts_calender: true,
      social_accounts_stream: true,
      social_accounts_messaging: true,
      social_accounts_posting: true,
      add_social_accounts: true,
      social_advertising_publishing: true,
      social_advertising_calender: true,
      social_advertising_reporting: true,
      post_integration_reporting: true,
      add_client_users: true,
    },
  ];
};
